export const resolveSrc = (src?: string): string | undefined => (src?.startsWith('//') ? `https:${src}` : src)

export function resolveSrcSet(srcInfo?: Gallery.Designs.McpImageSrcInfo, srcSet?: string): string | undefined {
  const size1x = resolveSrc(srcInfo?.size1x)
  const size2x = resolveSrc(srcInfo?.size2x)

  return srcInfo ? `${size1x} 1x, ${size2x} 2x` : srcSet
}
